function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "42",
  height: "42",
  viewBox: "0 0 42 42",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/locator",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Location-Button"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#0F0F0F",
  strokeWidth: "1.14",
  cx: "20",
  cy: "20",
  r: "20"
}), /*#__PURE__*/React.createElement("g", {
  id: "location3",
  transform: "translate(10 10)",
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.744 6.364C7.794 6.364 6.2 8 6.2 10s1.595 3.636 3.544 3.636c1.948 0 3.543-1.636 3.543-3.636s-1.595-3.636-3.543-3.636zm7.883 2.727c-.443-3.818-3.366-6.818-6.998-7.182V0H8.858v1.91c-3.72.363-6.644 3.363-6.998 7.18H0v1.82h1.86c.443 3.817 3.366 6.817 6.998 7.18V20h1.771v-1.91a8.02 8.02 0 006.998-7.18h1.86V9.09h-1.86zm-7.883 7.273c-3.455 0-6.2-2.819-6.2-6.364s2.745-6.364 6.2-6.364c3.454 0 6.2 2.819 6.2 6.364s-2.746 6.364-6.2 6.364z",
  id: "Shape"
})))))));